export default {"src":"/_next/static/image/public/images/verticalLine.7d6ffcc99bed03b849ff9e2f37480602.svg","height":57,"width":3};